export const colorSchemes = {
    default: 0,
    light: 1,
    dark: 2,
} as const
